import React, { memo } from 'react';
import styled from 'styled-components';

const TabBar = styled.div`
  display: flex;
  gap: 2px;
  padding: 6px 7px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  overflow-x: auto;
`;

const Tab = styled.button<{ $active: boolean }>`
  flex: 0 0 auto;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.tabHighlight : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primaryBase : theme.colors.secondaryText};
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 'normal')};
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s,
    color 0.15s;

  &:hover {
    background: ${({ theme }) => theme.colors.tabHighlight};
  }
`;

interface TabItem {
  value: string;
  label: string;
}

interface MapLayersTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

export const MapLayersTabs = memo<MapLayersTabsProps>(
  ({ tabs, activeTab, onTabChange }) => {
    if (tabs.length <= 1) {
      return null;
    }

    return (
      <TabBar data-name="map-layers-tabs">
        {tabs.map(tab => (
          <Tab
            key={tab.value}
            $active={activeTab === tab.value}
            onClick={() => onTabChange(tab.value)}
            data-name={`map-layers-tab-${tab.value}`}
          >
            {tab.label}
          </Tab>
        ))}
      </TabBar>
    );
  },
);
